<template>
  <div class="tableClass">
    <!-- 扫描框 START -->
    <div
      class="search-video-shadom"
      :style="{
        display: openVideoSearchType ? 'flex' : 'none'
      }"
    >
      <!-- 扫描框关闭按钮 START -->
      <el-button
        type="danger"
        icon="el-icon-switch-button"
        circle
        class="close-search-video-shadom"
        @click.stop="closeVideo"
      />
      <!-- 扫描框关闭按钮 END -->

      <!-- 扫描框提示语 START -->
      <div class="search-video-shadom-tips">请扫描商品条形码</div>
      <!-- 扫描框提示语 END -->

      <!-- 摄像头 START -->
      <video
        ref="video"
        id="video"
        autoplay
        playsinline
        webkit-playsinline="true"
        style="border: 1px solid gray; max-width: 500px"
      />
      <!-- 摄像头 END -->
    </div>
    <!-- 扫描框 END -->

    <!-- 条码系统标题 START -->
    <div class="title-container">
      <!-- <h3 class="title">和顺堂精品中药饮片溯源信息查询</h3> -->
        <img src="@/icons/traceability.svg" alt="icon" style="width:60px;height:60px">
    </div>
    <!-- 条码系统标题 END -->

    <!-- 搜索框模块 START -->
    <div style="margin: 15px 0" class="title-container">
      <!-- 搜索框 START -->
      <el-input
        placeholder="扫描条码或输入批号"
        v-model="inputValue"
        class="input-with-select"
        style="width: 90%"
        @keydown.enter.native="getCheckList"
      >
        <!-- 搜索框前的icon START -->
        <i
          v-if="!isLoading"
          slot="prefix"
          :class="
            openVideoSearchType
              ? 'el-input__icon el-icon-switch-button'
              : 'el-input__icon el-icon-full-screen'
          "
          :style="{ color: openVideoSearchType ? '#F56C6C' : '#67C23A' }"
          style="cursor: pointer;"
          @click.stop="openVideoSearch"
        />
        <i
          v-else
          slot="prefix"
          class="el-input__icon el-icon-loading"
          style="color: #409EFF; cursor: pointer;"
        />
        <!-- 搜索框前的icon END -->

        <!-- 搜索框后的搜索按钮 START -->
        <el-button
          slot="append"
          icon="el-icon-search"
          :loading="isLoading"
          @click="getCheckList"
        />
        <!-- 搜索框后的搜索按钮 END -->
      </el-input>
      <!-- 搜索框 END -->
    </div>

    <!-- PC端表格 食品厂 END -->

    <p
      v-if="quality.length > 0 && food.length > 0"
      class="title-class"
      :style="{ width: '100%', display: lookWidth >= 922 ? 'block' : 'none' }"
    >
      「{{ inputValue }}」 相关生产原料
    </p>

    <!-- <div  v-if="quality.length > 0 && qualityShow" :style="{
        width: '100%',
        overflow: 'auto',
        display: lookWidth >= 922 ? 'block' : 'none'
      }">
      <el-divider ><i class="iconfont icon-fenge"></i></el-divider>
    </div> -->
    <!-- && template === 2 -->
    <!-- PC端表格 品管部 START  width: 87%;-->
    <div v-if="Object.keys(quality).length > 0 " style="margin: 0 auto;" :style="{
        width: '100%',
        display: lookWidth >= 922 ? 'block' : 'none'
      }">
      <div class="productClass">
          <div class="productBoxClass">
            <!-- <img  src="@/icons/beverage.svg" alt="icon" style="width:60px;height:60px"> -->
            <el-divider >
              <div style="display: flex;align-items: center;gap: 5px;">
              <i v-if="template === 1" class="iconfont icon-jingpin icon-color"></i>
              <!-- <i v-if="template === 2" class="iconfont icon-zhongyao icon-color" style="color:#000000"></i> -->
              <i v-if="template === 4" class="iconfont icon-guixi icon-color" ></i>
              <img v-if="template === 2" src="@/icons/chinMedicine.svg" alt="icon" style="width:22px;height:22px;margin: 0;padding: 0;position: relative;top: -1px;">
              <img v-if="template === 3" src="@/icons/prescription.svg" alt="icon" style="width:22px;height:22px;margin: 0;padding: 0;position: relative;top: -3px;">
                <span :style="{color: template === 2 || template === 3 ? '#000000' : '#c49e0d'}">{{templateOptions[template]}}</span>
              </div>
            </el-divider>
            <div v-if="checkResultByRawData.product.images !==''" class="optionClass-img" style="margin: 0 auto;">
              
              <!-- height: 200px;margin-bottom: 10px;margin: 0 auto; -->
              <el-image  :src="checkResultByRawData.product.images" style="width: 100%; height: auto; max-height: 200px; object-fit: contain; margin: 0 auto;" :preview-src-list="checkResultByRawData.product.images">
                <div slot="error" class="image-slot" style="    margin: 0px auto;width: 300px;height: 200px;background: #f5f7fa;text-align: center;line-height: 200px">
                  暂无图片
                </div>
              </el-image>
            </div>
            <div class="optionClass">
              <span style="color: #c49e0d;">{{checkResultByRawData.product.name}}</span>
            </div>
            <div class="dashedClass"></div>
            <div class="optionClass">
              <span>成品批次</span>
              <span>{{checkResultByRawData.product.goods_batch || '-'}}</span>
            </div>
            <div class="dashedClass"></div>
            <div class="optionClass">
              <span>规格</span>
              <span>{{checkResultByRawData.product.spec || '-'}}</span>
            </div>
            <div class="dashedClass"></div>

            <div class="optionClass">
              <span>产地</span>
              <span>{{checkResultByRawData.product.origin || '-'}}</span>
            </div>
            <div class="dashedClass"></div>

            <div class="optionClass">
              <span>生产企业</span>
              <span>{{checkResultByRawData.product.factory}}</span>
            </div>
            <div class="dashedClass"></div>

            <div class="optionClass">
              <span>生产日期</span>
              <span>{{checkResultByRawData.product.production_time}}</span>
            </div>
            <div class="dashedClass"></div>

            <div v-if="checkResultByRawData.product.detection_status !== ''"  class="optionClass">
              <span>贮藏</span>
              <span>{{checkResultByRawData.product.detection_status}}</span>
            </div>
            <div v-if="checkResultByRawData.product.detection_status !== ''" class="dashedClass"></div>


            <div class="optionClass">
              <span>执行标准</span>
              <span>{{checkResultByRawData.product.standards}}</span>
            </div>
            <div class="dashedClass"></div>
        </div>
      </div>


      <el-collapse v-if="checkResultByRawData.base && Object.keys(checkResultByRawData.base).length > 0" accordion style="margin-top:20px;" class="collapseClass" @change="handleChange">
          <el-collapse-item :name="'base'">
            <template slot="title" class="collapseBoxClass" >
            <div class="templateClass">
              <span class="iconBorderClass">
                <i class="iconfont icon-yaocaikucunguanli icon-class" ></i>
              </span>
              基地信息
            </div>
              
            </template>

            <div v-if="checkResultByRawData.base !== undefined">
              <el-divider >基地介绍</el-divider>
              <div style="width: 80%;text-align: center; margin: 0 auto;">

                <el-carousel 
                  style="height: 100%;" class="base-images"
                >
                  <el-carousel-item 
                    v-for="item in checkResultByRawData.base.images" 
                    :key="item" 
                    :interval="5000"
                    style="height: 100%; width: 100%" 
                  >
                    <el-image 
                      class="el_carousel__item_image"
                      :src="item"
                      style="height: 400px"
                      fit="cover" 
                    >
                      <div slot="error" style="height:100%; display:flex; align-items:center; background:#f5f7fa">
                        暂无图片
                      </div>
                    </el-image>
                  </el-carousel-item>
                </el-carousel>

                <div class="carouselNameClass">
                  {{checkResultByRawData.base.name}}
                </div> 
              </div>

              <div style="margin-top:30px">
                <el-row :gutter="10">
                  <el-col :span="12">
                    <div class="blockClass">
                      <i class="iconfont icon-wendu iconfontClass"></i>
                      <div class="blockRigthClass">
                        <span>年均温度</span>
                        <span>{{checkResultByRawData.base.avg_temperature === '' ? '-' : checkResultByRawData.base.avg_temperature}}℃</span>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="blockClass">
                      <i class="iconfont icon-jiangyuliang iconfontClass"></i>
                      <div class="blockRigthClass">
                        <span>降雨量</span>
                        <span>{{checkResultByRawData.base.avg_rain === '' ? '-' : checkResultByRawData.base.avg_rain}}mm</span>
                      </div>
                    </div>
                  </el-col>
                </el-row>

                <el-row :gutter="10">
                  <el-col :span="12">
                    <div class="blockClass">
                      <i class="iconfont icon-jiwen iconfontClass"></i>
                      <div class="blockRigthClass">
                        <span>积温</span>
                        <span>{{checkResultByRawData.base.acc_temperature=== '' ? '-' : checkResultByRawData.base.acc_temperature}}℃</span>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="blockClass">
                      <i class="iconfont icon-leijiyuliang iconfontClass"></i>
                      <div class="blockRigthClass">
                        <span>积雨</span>
                        <span>{{checkResultByRawData.base.acc_rain=== '' ? '-' : checkResultByRawData.base.acc_rain}}mm</span>
                      </div>
                    </div>
                  </el-col>
                </el-row>

                <el-row :gutter="10">
                  <el-col :span="12">
                    <div class="blockClass">
                      <i class="iconfont icon-zhongzhimianjishuju iconfontClass"></i>
                      <div class="blockRigthClass">
                        <span>面积</span>
                        <span>{{checkResultByRawData.base.area=== '' ? '-' : checkResultByRawData.base.area}}亩</span>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="blockClass">
                      <i class="iconfont icon-haibagaodu iconfontClass"></i>
                      <div class="blockRigthClass">
                        <span>海拔</span>
                        <span>{{checkResultByRawData.base.altitude=== '' ? '-' : checkResultByRawData.base.altitude}}mm</span>
                      </div>
                    </div>
                  </el-col>
                </el-row>

              </div>

              <div>
                <el-divider >数字地图</el-divider>
                <div  id="container" style="width: 100%;height: 200px;"></div>
              </div>

            </div>
            <div>
              
            </div>
          </el-collapse-item>
      </el-collapse>
      <el-collapse v-if="checkResultByRawData.provenance && Object.keys(checkResultByRawData.provenance).length > 0" accordion style="margin-top:20px;" class="collapseClass">
        <el-collapse-item :name="1">
          <template slot="title" >
          <div class="templateClass">
            <span class="iconBorderClass"><i class="iconfont icon-plant" ></i></span>种源信息
          </div>
            
          </template>

          <div class="padding-class">
            <div class="optionClass">
              <span>种源批号</span>
              <span>{{checkResultByRawData.provenance.goods_batch}}</span>
            </div>
            <div class="dashedClass"></div>

            <div class="optionClass">
              <span>种子来源</span>
              <span>{{checkResultByRawData.provenance.source === 1 ? '自繁' : '外购'}}</span>
            </div>
            <div class="dashedClass"></div>

            <div class="optionClass">
              <span>基原</span>
              <span>{{checkResultByRawData.provenance.origin === '' ? '-' : checkResultByRawData.provenance.origin}}</span>
            </div>
            <div class="dashedClass"></div>
            <div class="optionClass">
              <span>等级</span>
              <span>{{checkResultByRawData.provenance.level === '' ? '-' : checkResultByRawData.provenance.level}}</span>
            </div>
            <div class="dashedClass"></div>

            <div class="optionClass">
              <span>培育地点</span>
              <span>{{checkResultByRawData.provenance.location === '' ? '-' : checkResultByRawData.provenance.location}}</span>
            </div>
            <div class="dashedClass"></div>
            <div class="optionClass">
              <span>贮藏条件</span>
              <span>{{checkResultByRawData.provenance.storage === '' ? '-' : checkResultByRawData.provenance.storage}}</span>
            </div>
            <div class="dashedClass"></div>
          </div>
        </el-collapse-item>
      </el-collapse>


      <el-collapse v-if="checkResultByRawData.planting && Object.keys(checkResultByRawData.planting).length > 0" accordion style="margin-top:20px;" class="collapseClass">
        <el-collapse-item :name="1">
          <template slot="title"  >
          <div class="templateClass">
            <span class="iconBorderClass"><i class="iconfont icon-zhongzhihu" ></i></span>种植信息
          </div>
            
          </template>

          <div class="padding-class">
              <!-- <el-divider >种植信息</el-divider> -->
            <div class="optionClass">
              <span>种植品种</span>
              <span>{{checkResultByRawData.planting.goods_name}}</span>
            </div>
            <div class="dashedClass"></div>

            <div class="optionClass">
              <span>种植批号</span>
              <span>{{checkResultByRawData.planting.goods_batch}}</span>
            </div>
            <div class="dashedClass"></div>
            <div class="optionClass">
              <span>种植方式</span>
              <span>{{checkResultByRawData.planting.method}}</span>
            </div>
            <div class="dashedClass"></div>

            <div class="optionClass">
              <span>种植时间</span>
              <span>{{checkResultByRawData.planting.time}}</span>
            </div>
            <div class="dashedClass"></div>

          </div>
          <div style="display: flex;justify-content: space-between;flex-wrap: wrap;">
              <el-card v-for="item in checkResultByRawData.planting.process" class="box-card card-class" style="flex: 0 0 24%">
                <div slot="header" class="clearfix">
                  <span>{{item.name}}</span>
                  <span style="float: right; padding: 3px 0" type="text">{{item.time}}</span>
                </div>
                <div  class="text item fixed-image" style="width: 100%;">
                  <el-image 
                      :src="item.images[0]" 
                      :preview-src-list="item.images"
                      fit="cover"
                      class="fixed-image" style="width: 100%;"
                      >
                    </el-image>
                </div>
              </el-card>
            </div>

        </el-collapse-item>
      </el-collapse>

      <el-collapse v-if="checkResultByRawData.harvest && Object.keys(checkResultByRawData.harvest).length > 0" accordion style="margin-top:20px;" class="collapseClass">
        <el-collapse-item :name="1">
          <template slot="title"  >
          <div class="templateClass">
            <span class="iconBorderClass"><i class="iconfont icon-caishou" ></i></span>采收信息
          </div>
            
          </template>

          <div class="padding-class">
            <!-- <el-divider >采收信息</el-divider> -->
            <div class="optionClass">
              <span>采收批号</span>
              <span>{{checkResultByRawData.harvest.goods_batch}}</span>
            </div>
            <div class="dashedClass"></div>

            <div class="optionClass">
              <span>采收部位</span>
              <span>{{checkResultByRawData.harvest.position}}</span>
            </div>
            <div class="dashedClass"></div>
            <div class="optionClass">
              <span>采收时间</span>
              <span>{{checkResultByRawData.harvest.time}}</span>
            </div>
            <div class="dashedClass"></div>
            <div class="optionClass">
              <span>采收方式</span>
              <span>{{checkResultByRawData.harvest.method}}</span>
            </div>
            <div class="dashedClass"></div>
          </div>
        </el-collapse-item>
      </el-collapse>

      <el-collapse v-if="checkResultByRawData.preliminary && Object.keys(checkResultByRawData.preliminary).length > 0" accordion style="margin-top:20px;" class="collapseClass">
        <el-collapse-item :name="1">
          <template slot="title">
          <div class="templateClass">
            <span class="iconBorderClass"><i class="iconfont icon-jiagongfuwu" ></i></span>加工信息
          </div>
            
          </template>

          <div >
            <div v-if="checkResultByRawData.preliminary !==''">
            <el-divider >初加工</el-divider>
            <div style="display: flex;justify-content: space-between;flex-wrap: wrap;">
              <el-card v-for="item in checkResultByRawData.preliminary" class="box-card card-class" style="flex: 0 0 24%" >
                <div slot="header" class="clearfix">
                  <span>{{item.name}}</span>
                  <span style="float: right; padding: 3px 0" type="text">{{item.time}}</span>
                </div>
                <div  class="text item fixed-image" style="width: 100%;">
                  <el-image 
                      :src="item.images[0]" 
                      :preview-src-list="item.images"
                      class="fixed-image" style="width: 100%;"
                      >
                    </el-image>
                </div>
              </el-card>
            </div>
          </div>

          <div v-if="checkResultByRawData.fine.length > 0 ">
            <el-divider >精加工</el-divider>
              <div style="display: flex;justify-content: space-between;flex-wrap: wrap;">
                <el-card v-for="item in checkResultByRawData.fine" class="box-card card-class" style="flex: 0 0 24%" >
                  <div slot="header" class="clearfix">
                    <span>{{item.name}}</span>
                    <span style="float: right; padding: 3px 0" type="text">{{item.time}}</span>
                  </div>
                  <div  class="text item fixed-image" style="width: 100%;">
                    <el-image 
                        :src="item.images[0]" 
                        :preview-src-list="item.images"
                        class="fixed-image" style="width: 100%;"
                        >
                      </el-image>
                  </div>
                </el-card>
              </div>
            </div>
          </div>

        </el-collapse-item>
      </el-collapse>
      <el-collapse v-if="checkResultByRawData.other_report && Object.keys(checkResultByRawData.other_report).length > 0" accordion style="margin-top:20px;" class="collapseClass">
        <el-collapse-item  :name="1">
          <template slot="title" style="border: 0px;box-shadow: 0 0.1rem 0.85rem 0 rgb(111 111 111 / 9%);padding: 0px 15px;border-radius: 2rem;" >
          <div class="templateClass">
            <span class="iconBorderClass"><i class="iconfont icon-qita" ></i></span>其他报告
          </div>
            
          </template>

          <div>
            <div style="display: flex;justify-content: space-around;">
              <el-card v-for="item in checkResultByRawData.other_report" class="box-card card-class" >
                <div slot="header" class="clearfix">
                  <span>{{item.name}}</span>
                </div>
                <div  class="text item">
                  <el-image 
                      :src="item.images[0]" 
                      :preview-src-list="item.images"
                      >
                    </el-image>
                </div>
              </el-card>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>

      <el-collapse v-if="checkResultByRawData.produce && Object.keys(checkResultByRawData.produce).length > 0" accordion style="margin-top:20px;" class="collapseClass">
        <el-collapse-item :name="1">
          <template slot="title"  >
          <div class="templateClass">
            <span class="iconBorderClass"><i class="iconfont icon-a-ziyuan103" ></i></span>生产信息
          </div>
            
          </template>
        <div style="display: flex;justify-content: space-between;flex-wrap: wrap;">
              <el-card v-for="item in checkResultByRawData.produce" class="box-card card-class produceClass"  style="flex: 0 0 24%">
                <div slot="header" class="clearfix">
                  <span>{{item.name}}</span>
                </div>
                <div  class="text item fixed-image" style="width: 100%;">
                  <el-image 
                      :src="item.url[0]" 
                      :preview-src-list="item.url"
                      fit="cover"
                      class="fixed-image" style="width: 100%;"
                      >
                    </el-image>
                </div>
              </el-card>
            </div>
        </el-collapse-item>
      </el-collapse>
      <!-- 留样信息 -->
      <el-collapse v-if="checkResultByRawData.sample && Object.keys(checkResultByRawData.sample).length > 0" accordion style="margin-top:20px;" class="collapseClass">
        <el-collapse-item :name="1">
          <template slot="title"  >
          <div class="templateClass">
            <span class="iconBorderClass"><i class="iconfont icon-liuyangjilu" ></i></span>留样信息
          </div>
            
          </template>
            <div style="display: flex;justify-content: space-between;flex-wrap: wrap;">
                <el-card v-for="item in checkResultByRawData.sample.images" class="box-card card-class produceClass"  style="flex: 0 0 24%" >
                  <div  class="text item fixed-image" style="width: 100%;">
                  <el-image 
                      :src="item" 
                      :preview-src-list="checkResultByRawData.sample.images"
                      fit="cover"
                      class="fixed-image" style="width: 100%;"
                      >
                    </el-image>
                </div>
                </el-card>

              </div>
        </el-collapse-item>
      </el-collapse>



      <el-collapse v-if="checkResultByRawData.storage &&  Object.keys(checkResultByRawData.storage).length > 0" accordion style="margin-top:20px;" class="collapseClass">
        <el-collapse-item :name="1">
          <template slot="title"  >
          <div class="templateClass">
            <span class="iconBorderClass"><i class="iconfont icon-wodekucun" ></i></span>仓储信息
          </div>
            
          </template>
          <div class="padding-class">
            <div v-if="checkResultByRawData.storage.environment !=''" >
            <!-- <el-divider >仓储信息</el-divider> -->

            <div class="optionClass">
              <span>仓储条件</span>
              <span>{{checkResultByRawData.storage.environment}}</span>
            </div>
            <div class="dashedClass"></div>

          </div>
        <div style="display: flex;justify-content: space-between;">
              <el-card v-for="item in checkResultByRawData.storage.url" class="box-card card-class" >
                <div  class="text item">
                  <el-image 
                      :src="item" 
                      :preview-src-list="checkResultByRawData.storage.url"
                      >
                    </el-image>
                </div>
              </el-card>
            </div>
          </div>
          
        </el-collapse-item>
      </el-collapse>
      <!-- transport -->

      <!-- 运输信息 -->
      <el-collapse v-if="checkResultByRawData.transport && Object.keys(checkResultByRawData.transport).length > 0" accordion style="margin-top:20px;" class="collapseClass">
        <el-collapse-item :name="1">
          <template slot="title"  >
          <div class="templateClass">
            <span class="iconBorderClass"><i class="iconfont icon-yunshu" ></i></span>运输信息
          </div>
            
          </template>
          <div style="display: flex;justify-content: space-between;flex-wrap: wrap;">
                <el-card v-for="item in checkResultByRawData.transport.images" class="box-card card-class produceClass"  style="flex: 0 0 24%" >
                  <div  class="text item fixed-image" style="width: 100%;">
                  <el-image 
                      :src="item" 
                      :preview-src-list="checkResultByRawData.transport.images"
                      fit="cover"
                      class="fixed-image" style="width: 100%;"
                      >
                    </el-image>
                </div>
                </el-card>

              </div>
        </el-collapse-item>
      </el-collapse>


      <el-collapse v-if="checkResultByRawData.sale &&  Object.keys(checkResultByRawData.sale).length > 0" accordion style="margin-top:20px;" class="collapseClass">
        <el-collapse-item :name="1">
          <template slot="title"  >
          <div class="templateClass">
            <span class="iconBorderClass"><i class="iconfont icon-qiye" ></i></span>销售信息
          </div>
            
          </template>
          <div class="padding-class">
            <div v-if="checkResultByRawData.sale.name !=''" >

            <div class="optionClass">
              <span>客户名称</span>
              <span>{{checkResultByRawData.sale.name}}</span>
            </div>
            <div class="dashedClass"></div>

          </div>
          </div>
          
        </el-collapse-item>
      </el-collapse>




      <!-- 新加PC端 S -->
      <!-- v-if="checkResultByRawData.raw !== undefined" -->
      <el-collapse  v-model="activeName1" accordion style="margin-top:20px;" class="collapseClass" @change="rawChange" >
          <el-collapse-item :name="1">
            <template slot="title" style="border: 0px;
    box-shadow: 0 0.1rem 0.85rem 0 rgb(111 111 111 / 9%);
    padding: 0px 15px;border-radius: 2rem;" >
            <div class="templateClass">
              <span class="iconBorderClass"><i class="iconfont icon-zhiliang" ></i></span>
              质量信息
            </div>
              
            </template>
            <el-tabs v-model="activeName" @tab-click="handleClick" stretch>
              <el-tab-pane v-if="checkResultByRawData.raw !== undefined && (checkResultByRawData.raw.length > 0 || Object.keys(checkResultByRawData.raw || {}).length)" label="原料" name="first">
                  <div>
                  <el-divider >检测信息</el-divider>
                </div>
                <div style="display: flex;justify-content: space-around;">
                <el-card class="box-card card-class" style="width: 100%;">
                  <div  class="text item">
                      <div class="pdf pdfClass" v-if="checkResultByRawData.raw.url !== ''">
                        <div class="pdf-tab">
                          <div style="text-aligin:center">
                            <iframe
                                :src="checkResultByRawData.raw.url"
                                frameborder="0"
                                scrolling="no"
                                style="width: 100%; height: 500px;border:none"
                              />
                          </div>
                        </div>
                      </div>



                  </div>
                  </el-card>
                </div>
              </el-tab-pane>
              <div v-if="activeName === 'second' && numShow">
                <div v-if="checkResultByRawData.dna !== undefined && (checkResultByRawData.dna.length > 0 || Object.keys(checkResultByRawData.dna || {}).length)">
                    <el-divider style="width: 92%;margin: 0 auto;">基因测序</el-divider>
                    <div style="display: flex;justify-content: space-around;flex-wrap: wrap;">
                      <el-card class="box-card card-class" style="width:48%">
                        <div slot="header" class="clearfix">
                          <span>PCB产物凝胶电池图</span>
                        </div>
                        <div  class="text item " style="text-align: center;">
                          <el-image 
                              :src="checkResultByRawData.dna.images" 
                              :preview-src-list="checkResultByRawData.dna.images"
                              style="width: 80%;"
                              >
                            </el-image>
                        </div>
                      </el-card>
                      <el-card class="box-card card-class" style="width:48%">
                        <div slot="header" class="clearfix">
                          <span>样本DNA序列</span>
                        </div>
                        <div  class="text item " style="display: flex;justify-content: center;">
                            <canvas v-show="showErrMsg" ref="qrcode"  style="display: flex;justify-content: center;align-items: center;height: 200px;width:100%;object-fit: cover"></canvas>
                        </div>
                      </el-card>
                    </div>
                </div>


                <div v-if="checkResultByRawData.check !== undefined">
                  <template >
                    <div v-for="(data, type) in tableCheckResultByRawData" :key="type">
                      <el-divider style="width: 92%; margin: 0 auto;" v-if="data.length > 0">
                      {{ typeLabels[type] }}
                    </el-divider>

                    <div style="width: 92%; margin: 0 auto;" v-if="data.length > 0">
                      <custom-table :data="data" :options="options" :title="checkResultByRawData.check.title" :lookWidth="lookWidth" />
                    </div>
                    </div>
                  </template>
                </div>

                  

                  <div v-if="checkResultByRawData.images">
                    <el-divider style="width: 92%;margin: 0 auto;">片形比较</el-divider>
                    <div style="display: flex;justify-content: space-around;    flex-wrap: wrap;">
                      <el-card v-for="item in checkResultByRawData.images" class="box-card card-class" style="width:48%">
                        <div  class="text item">
                          <el-image  style="width: 100%;height: 200px;"
                              :src="item" 
                              :preview-src-list="checkResultByRawData.images"
                              >
                            </el-image>
                        </div>
                      </el-card>

                      
                    </div>
                  </div>

                <div style="margin-top:10px">
                  <el-divider style="width: 92%;margin: 0 auto;">检测信息</el-divider>
                <div class="pdf pdfClass" v-if="checkResultByRawData.quality.picture_url !== ''">
                  <div class="pdf-tab">
                    <div style="text-align:center">
                      <iframe
                          v-for="(url, index) in checkResultByRawData.quality.picture_url"
                          :key="index"
                          :src="url"
                          frameborder="0"
                          scrolling="no"
                          style="width: 100%; height: 500px;border:none"
                        />

                    </div>
                  </div>
                </div>
                </div>
              </div>
              <el-tab-pane v-else label="成品" name="second">
                <div v-if="checkResultByRawData.dna !== undefined && (checkResultByRawData.dna.length > 0 || Object.keys(checkResultByRawData.dna || {}).length)">
                    <el-divider style="width: 92%;margin: 0 auto;">基因测序</el-divider>
                    <div style="display: flex;justify-content: space-around;flex-wrap: wrap;">
                      <el-card class="box-card card-class" style="width:48%">
                        <div slot="header" class="clearfix">
                          <span>PCB产物凝胶电池图</span>
                        </div>
                        <div  class="text item " style="text-align: center;">
                          <el-image 
                              :src="checkResultByRawData.dna.images" 
                              :preview-src-list="checkResultByRawData.dna.images"
                              style="width: 80%;"
                              >
                            </el-image>
                        </div>
                      </el-card>
                      <el-card class="box-card card-class" style="width:48%">
                        <div slot="header" class="clearfix">
                          <span>样本DNA序列</span>
                        </div>
                        <div  class="text item " style="display: flex;justify-content: center;">
                            <canvas v-show="showErrMsg" ref="qrcode"  style="display: flex;justify-content: center;align-items: center;height: 200px;width:100%;object-fit: cover"></canvas>
                        </div>
                      </el-card>
                    </div>
                </div>


                <div v-if="checkResultByRawData.check !== undefined">
                  <template >
                    <div v-for="(data, type) in tableCheckResultByRawData" :key="type">
                      <el-divider style="width: 92%; margin: 0 auto;" v-if="data.length > 0">
                      {{ typeLabels[type] }}
                    </el-divider>

                    <div style="width: 92%; margin: 0 auto;" v-if="data.length > 0">
                      <custom-table :data="data" :options="options" :title="checkResultByRawData.check.title" :lookWidth="lookWidth" />
                    </div>
                    </div>
                  </template>
                </div>

                  

                  <div v-if="checkResultByRawData.images">
                    <el-divider style="width: 92%;margin: 0 auto;">片形比较</el-divider>
                    <div style="display: flex;justify-content: space-around;    flex-wrap: wrap;">
                      <el-card v-for="item in checkResultByRawData.images" class="box-card card-class" style="width:48%">
                        <div  class="text item">
                          <el-image  style="width: 100%;height: 200px;"
                              :src="item" 
                              :preview-src-list="checkResultByRawData.images"
                              >
                            </el-image>
                        </div>
                      </el-card>

                      
                    </div>
                  </div>

                <div style="margin-top:10px">
                  <el-divider style="width: 92%;margin: 0 auto;">检测信息</el-divider>
                <div class="pdf pdfClass" v-if="checkResultByRawData.quality.picture_url !== ''">
                  <div class="pdf-tab">
                    <div style="text-align:center">
                      <iframe
                          v-for="(url, index) in checkResultByRawData.quality.picture_url"
                          :key="index"
                          :src="url"
                          frameborder="0"
                          scrolling="no"
                          style="width: 100%; height: 500px;border:none"
                        />

                    </div>
                  </div>
                </div>
                </div>
              </el-tab-pane>
          </el-tabs>


          </el-collapse-item>
      </el-collapse>
        <!-- 新加PC端 E -->


    </div>
    <!-- PC端表格 品管部 END -->

    <!-- 显示未找到相关记录 -->
    <p v-else-if="showTitle !== ''" class="showTitle-class">
      {{ showTitle }}
    </p>
    <!-- {{ code.length > 0 && codeShowTable }}啊啊啊
    {{code}} -->
    <!-- 移动端表格 START 商品条码查询 -->
    <div v-if="code.length > 0 && codeShowTable ">
    <el-table
      :data="code"
      class="miniCodeTable"
      @row-click="handleCellClick"
      style="width: 100%"
    >
      <el-table-column
        prop="goods_name"
        label="品名"
        width="80"
      ></el-table-column>
      <el-table-column prop="origin" label="产地">
        <template slot-scope="scope">
          {{scope.row.origin || '-'}}
        </template>
      </el-table-column>
      
      <el-table-column prop="batch_number" label="批号" >
      </el-table-column>
      <el-table-column label="生产日期" width="108">
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper">
            <el-tag size="medium" style="cursor: pointer; padding: 0 2px">{{
              timeFormat(scope.row.production_time)
            }}</el-tag>
          </div>
        </template>
      </el-table-column>
    </el-table>
    </div>
    <!-- 移动端表格 商品条码查询 END -->

    <!-- 移动端表格 START 食品厂 -->
    <div
      v-if="food.length > 0"
      class="phone-table"
      :style="{ display: lookWidth < 922 ? 'block' : 'none' }"
    >
      <el-card
        v-for="(item, index) in food"
        :body-style="{ padding: '0px' }"
        class="phone-table-items"
        :key="index"
      >
        <el-collapse v-model="foodActiveNames">
          <el-collapse-item
            v-for="(tableOptionsItem, tableOptionsIndex) in foodOptions"
            :title="tableOptionsItem.title"
            :name="`${index}${tableOptionsIndex + 1}`"
            :key="tableOptionsIndex"
          >
            <span v-if="tableOptionsItem.title === '生产日期'">{{
              timeFormat(item[tableOptionsItem.prop])
            }}</span>
            <span v-else>{{ item[tableOptionsItem.prop] }}</span>
          </el-collapse-item>
          <el-collapse-item title="检验报告图片" :name="`${index}0`">
            <div>
              <el-image
                v-for="itemValue in foodGood"
                :key="itemValue"
                class="image"
                :src="itemValue"
                :preview-src-list="srcList"
              />
              <div v-if="foodGoodPDF.length > 0" class="pdf">
                <div class="pdf-tab">
                  <div v-for="(item, index) in foodGoodPDF" :key="index">
                    <pdf v-for="i in numPages" :key="i" :src="item" :page="i">
                    </pdf>
                  </div>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-card>
    </div>
  
    <p
      v-if="quality.length > 0 && food.length > 0"
      class="title-class"
      :style="{ display: lookWidth < 922 ? 'block' : 'none' }"
    >
      「{{ inputValue }}」 相关生产原料
    </p>
 
    <div
      v-if="Object.keys(quality).length > 0 "
      class="phone-table"
      :style="{ display: lookWidth < 922 ? 'block' : 'none' }"
    >

      <div class="productClass" v-if="checkResultByRawData.product !==undefined">
            <div class="productBoxClass">
              <el-divider >
                <div style="display: flex;align-items: center;gap: 5px;">
                  <i v-if="template === 1" class="iconfont icon-jingpin icon-color"></i>
                  <!-- <i v-if="template === 2" class="iconfont icon-zhongyao icon-color" style="color:#000000"></i> -->
                  <i v-if="template === 4" class="iconfont icon-guixi icon-color" ></i>
                   <img v-if="template === 2" src="@/icons/chinMedicine.svg" alt="icon" style="width:22px;height:22px;margin: 0;padding: 0;position: relative;top: 0px;">
                  <img v-if="template === 3" src="@/icons/prescription.svg" alt="icon" style="width:22px;height:22px;margin: 0;padding: 0;position: relative;top: -3px;">
                  <span :style="{color: template === 2 || template === 3 ? '#000000' : '#c49e0d'}">{{templateOptions[template]}}</span>
                </div>
              </el-divider>
              <div v-if="checkResultByRawData.product.images !==''" class="optionClass" >
                <!-- <el-image 
                      style="height: 200px;margin-bottom: 10px;margin: 0 auto;"
                      :src="checkResultByRawData.product.images" 
                      :preview-src-list="checkResultByRawData.product.images"
                      >
                      </el-image>  -->

                      <el-image :src="checkResultByRawData.product.images" style="height: 200px;margin-bottom: 10px;margin: 0 auto;" :preview-src-list="checkResultByRawData.product.images">
                        <div slot="error" class="image-slot" style="    margin: 0px auto;width: 300px;height: 200px;background: #f5f7fa;text-align: center;line-height: 200px">
                          暂无图片
                        </div>
                      </el-image>

              </div>
                      
              <div class="optionClass">
                <span style="color: #c49e0d;">{{checkResultByRawData.product.name}}</span>
              </div>
              <div class="dashedClass"></div>
              <div class="optionClass">
                <span>成品批次</span>
                <span>{{checkResultByRawData.product.goods_batch || '-'}}</span>
              </div>
              <div class="dashedClass"></div>
              <div class="optionClass">
                <span>规格</span>
                <span>{{checkResultByRawData.product.spec || '-'}}</span>
              </div>
              <div class="dashedClass"></div>

              <div class="optionClass">
                <span>产地</span>
                <span>{{checkResultByRawData.product.origin || '-'}}</span>
              </div>
              <div class="dashedClass"></div>

              <div class="optionClass">
                <span>生产企业</span>
                <span>{{checkResultByRawData.product.factory || '-'}}</span>
              </div>
              <div class="dashedClass"></div>

              <div class="optionClass">
                <span>生产日期</span>
                <span>{{checkResultByRawData.product.production_time}}</span>
              </div>
              <div class="dashedClass"></div>

              <div v-if="checkResultByRawData.product.detection_status !== ''"  class="optionClass">
                <span>贮藏</span>
                <span>{{checkResultByRawData.product.detection_status}}</span>
              </div>
              <div v-if="checkResultByRawData.product.detection_status !== ''" class="dashedClass"></div>

              <div class="optionClass">
                <span style="width:200px;min-width: 100px;">执行标准</span>
                <span>{{checkResultByRawData.product.standards}}</span>
              </div>
              <div class="dashedClass"></div>
              
          </div>
      </div>

      <el-collapse v-if="checkResultByRawData.base &&  Object.keys(checkResultByRawData.base).length > 0" accordion style="margin-top:20px;" class="collapseClass" @change="handleChange">
          <el-collapse-item :name="'base'">
            <template slot="title" style="border: 0px;
    box-shadow: 0 0.1rem 0.85rem 0 rgb(111 111 111 / 9%);
    padding: 0px 15px;border-radius: 2rem;" >
            <div class="templateClass">
              <span class="iconBorderClass"><i class="iconfont icon-yaocaikucunguanli" ></i></span>基地信息
            </div>
              
            </template>

            <div>
              <el-divider >基地介绍</el-divider>
              <div>
                <el-carousel style="height:100%;text-align: center;" class="base-images">
                  <el-carousel-item v-for="item in checkResultByRawData.base.images" :key="item" :interval="5000" style="height:100%;width:100%">
                    <el-image class="el_carousel__item_image" :src="item" style="height:400px" fit="cover"></el-image>
                  </el-carousel-item>
                </el-carousel>
                <div class="carouselNameClass">
                  {{checkResultByRawData.base.name}}
                </div> 
              </div>

              <div style="margin-top:30px">
                <el-row :gutter="10">
                  <el-col :span="12">
                    <div class="blockClass">
                      <i class="iconfont icon-wendu iconfontClass"></i>
                      <div class="blockRigthClass">
                        <span>年均温度</span>
                        <span>{{checkResultByRawData.base.avg_temperature === '' ? '-' : checkResultByRawData.base.avg_temperature}}℃</span>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="blockClass">
                      <i class="iconfont icon-jiangyuliang iconfontClass"></i>
                      <div class="blockRigthClass">
                        <span>降雨量</span>
                        <span>{{checkResultByRawData.base.avg_rain === '' ? '-' : checkResultByRawData.base.avg_rain}}mm</span>
                      </div>
                    </div>
                  </el-col>
                </el-row>

                <el-row :gutter="10">
                  <el-col :span="12">
                    <div class="blockClass">
                      <i class="iconfont icon-jiwen iconfontClass"></i>
                      <div class="blockRigthClass">
                        <span>积温</span>
                        <span>{{checkResultByRawData.base.acc_temperature=== '' ? '-' : checkResultByRawData.base.acc_temperature}}℃</span>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="blockClass">
                      <i class="iconfont icon-leijiyuliang iconfontClass"></i>
                      <div class="blockRigthClass">
                        <span>积雨</span>
                        <span>{{checkResultByRawData.base.acc_rain=== '' ? '-' : checkResultByRawData.base.acc_rain}}mm</span>
                      </div>
                    </div>
                  </el-col>
                </el-row>

                <el-row :gutter="10">
                  <el-col :span="12">
                    <div class="blockClass">
                      <i class="iconfont icon-zhongzhimianjishuju iconfontClass"></i>
                      <div class="blockRigthClass">
                        <span>面积</span>
                        <span>{{checkResultByRawData.base.area=== '' ? '-' : checkResultByRawData.base.area}}亩</span>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="blockClass">
                      <i class="iconfont icon-haibagaodu iconfontClass"></i>
                      <div class="blockRigthClass">
                        <span>海拔</span>
                        <span>{{checkResultByRawData.base.altitude=== '' ? '-' : checkResultByRawData.base.altitude}}mm</span>
                      </div>
                    </div>
                  </el-col>
                </el-row>

              </div>

              <div>
                <el-divider >数字地图</el-divider>
                <div id="containerBox" style="width: 100%;height: 200px;"></div>
              </div>

            </div>
            <div>
              
            </div>
          </el-collapse-item>
      </el-collapse>
      
      <el-collapse v-if="checkResultByRawData.provenance &&  Object.keys(checkResultByRawData.provenance).length > 0" accordion style="margin-top:20px;" class="collapseClass">
          <el-collapse-item :name="1">
            <template slot="title"  >
            <div class="templateClass">
              <span class="iconBorderClass"><i class="iconfont icon-plant" ></i></span>种源信息
            </div>
              
            </template>

            <div  class="padding-class">

              <div class="optionClass">
                <span>种源批号</span>
                <span>{{checkResultByRawData.provenance.goods_batch}}</span>
              </div>
              <div class="dashedClass"></div>
              <div class="optionClass">
                <span>种子来源</span>
                <span>{{checkResultByRawData.provenance.source === 1 ? '自繁' : '外购'}}</span>
              </div>
              <div class="dashedClass"></div>

              <div class="optionClass">
                <span>基原</span>
                <span>{{checkResultByRawData.provenance.origin === '' ? '-' : checkResultByRawData.provenance.origin}}</span>
              </div>
              <div class="dashedClass"></div>
              <div class="optionClass">
                <span>等级</span>
                <span>{{checkResultByRawData.provenance.level === '' ? '-' : checkResultByRawData.provenance.level}}</span>
              </div>
              <div class="dashedClass"></div>

              <div class="optionClass">
                <span>培育地点</span>
                <span>{{checkResultByRawData.provenance.location === '' ? '-' : checkResultByRawData.provenance.location}}</span>
              </div>
              <div class="dashedClass"></div>
              <div class="optionClass">
                <span>贮藏条件</span>
                <span>{{checkResultByRawData.provenance.storage === '' ? '-' : checkResultByRawData.provenance.storage}}</span>
              </div>
              <div class="dashedClass"></div>


            </div>
          </el-collapse-item>
      </el-collapse>

      <el-collapse v-if="checkResultByRawData.planting &&  Object.keys(checkResultByRawData.planting).length > 0" accordion style="margin-top:20px;" class="collapseClass">
          <el-collapse-item :name="1">
            <template slot="title"  >
            <div class="templateClass">
              <span class="iconBorderClass"><i class="iconfont icon-zhongzhihu" ></i></span>种植信息
            </div>
              
            </template>

            <div  class="padding-class">
              <!-- <el-divider >种植信息</el-divider> -->
              <div class="optionClass">
                <span>种植品种</span>
                <span>{{checkResultByRawData.planting.goods_name}}</span>
              </div>
              <div class="dashedClass"></div>

              <div class="optionClass">
                <span>种植批号</span>
                <span>{{checkResultByRawData.planting.goods_batch}}</span>
              </div>
              <div class="dashedClass"></div>
              <div class="optionClass">
                <span>种植方式</span>
                <span>{{checkResultByRawData.planting.method}}</span>
              </div>
              <div class="dashedClass"></div>

              <div class="optionClass">
                <span>种植时间</span>
                <span>{{checkResultByRawData.planting.time}}</span>
              </div>
              <div class="dashedClass"></div>

            </div>
            <div>
                <el-card v-for="item in checkResultByRawData.planting.process" class="box-card card-class" style="width: 98%;">
                  <div slot="header" class="clearfix">
                    <span>{{item.name}}</span>
                    <span style="float: right; padding: 3px 0" type="text">{{item.time}}</span>
                  </div>
                  <div  class="text item">
                    <el-image 
                        style="width: 100%;height: 200px;"
                        :src="item.images[0]" 
                        :preview-src-list="item.images"
                        >
                      </el-image>
                  </div>
                </el-card>
              </div>
          </el-collapse-item>
      </el-collapse>

      <el-collapse v-if="checkResultByRawData.harvest &&  Object.keys(checkResultByRawData.harvest).length > 0"  accordion style="margin-top:20px;" class="collapseClass">
          <el-collapse-item :name="1">
            <template slot="title" >
            <div class="templateClass">
              <span class="iconBorderClass"><i class="iconfont icon-caishou" ></i></span>采收信息
            </div>
              
            </template>

            <div  class="padding-class">
              <!-- <el-divider >采收信息</el-divider> -->
              <div class="optionClass">
                <span>采收批号</span>
                <span>{{checkResultByRawData.harvest.goods_batch}}</span>
              </div>
              <div class="dashedClass"></div>

              <div class="optionClass">
                <span>采收部位</span>
                <span>{{checkResultByRawData.harvest.position}}</span>
              </div>
              <div class="dashedClass"></div>
              <div class="optionClass">
                <span>采收时间</span>
                <span>{{checkResultByRawData.harvest.time}}</span>
              </div>
            <div class="dashedClass"></div>
              <div class="optionClass">
                <span>采收方式</span>
                <span>{{checkResultByRawData.harvest.method}}</span>
              </div>
              <div class="dashedClass"></div>
            </div>
          </el-collapse-item>
      </el-collapse>

      <el-collapse v-if="checkResultByRawData.preliminary &&  Object.keys(checkResultByRawData.preliminary).length > 0" accordion style="margin-top:20px;" class="collapseClass">
          <el-collapse-item :name="1">
            <template slot="title"  >
            <div class="templateClass">
              <span class="iconBorderClass"><i class="iconfont icon-jiagongfuwu" ></i></span>加工信息
            </div>
              
            </template>

            <div>
              <div v-if="checkResultByRawData.preliminary !=''">
                <el-divider >初加工</el-divider>
                <el-card v-for="item in checkResultByRawData.preliminary" class="box-card card-class" style="width: 98%;">
                  <div slot="header" class="clearfix">
                    <span>{{item.name}}</span>
                    <span style="float: right; padding: 3px 0" type="text">{{item.time}}</span>
                  </div>
                  <div  class="text item">
                    <el-image 
                        style="width: 100%;height: 200px;"
                        :src="item.images[0]" 
                        :preview-src-list="item.images"
                        fit="cover"
                        >
                      </el-image>
                  </div>
                </el-card>
              </div>
            </div>


            <div>
              <div v-if="checkResultByRawData.fine !=''">
                <el-divider >精加工</el-divider>
                <el-card v-for="item in checkResultByRawData.fine" class="box-card card-class" style="width: 98%;">
                  <div slot="header" class="clearfix">
                    <span>{{item.name}}</span>
                    <span style="float: right; padding: 3px 0" type="text">{{item.time}}</span>
                  </div>
                  <div  class="text item">
                    <el-image 
                        style="width: 100%;height: 200px;"
                        :src="item.images[0]" 
                        :preview-src-list="item.images"
                        fit="cover"
                        >
                      </el-image>
                  </div>
                </el-card>
              </div>
            </div>

          </el-collapse-item>
      </el-collapse>
      <el-collapse v-if="checkResultByRawData.other_report &&  Object.keys(checkResultByRawData.other_report).length > 0"  accordion style="margin-top:20px;" class="collapseClass">
          <el-collapse-item :name="1">
            <template slot="title"  >
            <div class="templateClass">
              <span class="iconBorderClass"><i class="iconfont icon-qita" ></i></span>其他报告
            </div>
              
            </template>

            <div>
              <div>
                <el-card v-for="item in checkResultByRawData.other_report" class="box-card card-class" style="width: 98%;">
                  <div slot="header" class="clearfix">
                    <span>{{item.name}}</span>
                  </div>
                  <div  class="text item">
                    <el-image 
                        style="width: 100%;height: 200px;"
                        :src="item.images[0]" 
                        :preview-src-list="item.images"
                        fit="cover"
                        >
                      </el-image>
                  </div>
                </el-card>
              </div>
            </div>
          </el-collapse-item>
      </el-collapse>
      <!-- 生产信息 -->
      <el-collapse v-if="checkResultByRawData.produce &&  Object.keys(checkResultByRawData.produce).length > 0"  accordion style="margin-top:20px;" class="collapseClass">
          <el-collapse-item :name="1">
            <template slot="title"  >
            <div class="templateClass">
              <span class="iconBorderClass"><i class="iconfont icon-a-ziyuan103" ></i></span>生产信息
            </div>
              
            </template>

            <div>
              <div>
                <el-card v-for="item in checkResultByRawData.produce" class="box-card card-class" style="width: 98%;">
                  <div slot="header" class="clearfix">
                    <span>{{item.name}}</span>
                  </div>
                  <div  class="text item">
                    <el-image 
                        style="width: 100%;height: 200px;"
                        :src="item.url[0]" 
                        :preview-src-list="item.url"
                        fit="cover"
                        >
                      </el-image>
                  </div>
                </el-card>
              </div>
            </div>
          </el-collapse-item>
      </el-collapse>
      <!-- 留样信息 -->
      <el-collapse v-if="checkResultByRawData.sample &&  Object.keys(checkResultByRawData.sample).length > 0"  accordion style="margin-top:20px;" class="collapseClass">
          <el-collapse-item :name="1">
            <template slot="title"  >
            <div class="templateClass">
              <span class="iconBorderClass"><i class="iconfont icon-liuyangjilu" ></i></span>留样信息
            </div>
              
            </template>

            <div>
              <div>
                <el-card v-for="item in checkResultByRawData.sample.images" class="box-card card-class" style="width: 98%;">
                  <div  class="text item">
                    <el-image 
                        style="width: 100%;height: 200px;"
                        :src="item" 
                        :preview-src-list="checkResultByRawData.sample.images"
                        fit="cover"
                        >
                      </el-image>
                  </div>
                </el-card>
              </div>
            </div>
          </el-collapse-item>
      </el-collapse>
    <!-- && template ===2 -->
      <!-- 仓储信息 -->
      <el-collapse v-if="checkResultByRawData.storage &&  Object.keys(checkResultByRawData.storage).length > 0 " accordion style="margin-top:20px;" class="collapseClass">
          <el-collapse-item :name="1">
            <template slot="title"  >
            <div class="templateClass">
              <span class="iconBorderClass"><i class="iconfont icon-wodekucun" ></i></span>仓储信息
            </div>
              
            </template>
            <div class="padding-class">
              <div v-if="checkResultByRawData.storage.environment !=''">
              <!-- <el-divider >仓储信息</el-divider> -->
              <div class="optionClass">
                <span>仓储条件</span>
                <span>{{checkResultByRawData.storage.environment}}</span>
              </div>
              <div class="dashedClass"></div>

            </div>
            <div>
                <el-card v-for="item in checkResultByRawData.storage.url" class="box-card card-class" style="width: 98%;">
                  <div  class="text item">
                    <el-image 
                        style="width: 100%;height: 200px;"
                        :src="item" 
                        :preview-src-list="item"
                        fit="cover"
                        >
                      </el-image>
                  </div>
                </el-card>
              </div>
            </div>
            
          </el-collapse-item>
      </el-collapse>

      <!-- 运输信息 -->
      <el-collapse v-if="checkResultByRawData.transport &&  Object.keys(checkResultByRawData.transport).length > 0"  accordion style="margin-top:20px;" class="collapseClass">
          <el-collapse-item :name="1">
            <template slot="title"  >
            <div class="templateClass">
              <span class="iconBorderClass"><i class="iconfont icon-yunshu" ></i></span>运输信息
            </div>
              
            </template>

            <div>
              <div>
                <el-card v-for="item in checkResultByRawData.transport.images" class="box-card card-class" style="width: 98%;">
                  <div  class="text item">
                    <el-image 
                        style="width: 100%;height: 200px;"
                        :src="item" 
                        :preview-src-list="checkResultByRawData.transport.images"
                        fit="cover"
                        >
                      </el-image>
                  </div>
                </el-card>
              </div>
            </div>
          </el-collapse-item>
      </el-collapse>


      <!-- 销售信息 -->
      <el-collapse v-if="checkResultByRawData.sale &&  Object.keys(checkResultByRawData.sale).length > 0"  accordion style="margin-top:20px;" class="collapseClass">
          <el-collapse-item :name="1">
            <template slot="title"  >
            <div class="templateClass">
              <span class="iconBorderClass"><i class="iconfont icon-qiye" ></i></span>销售信息
            </div>
              
            </template>
            <div class="padding-class">
              <div v-if="checkResultByRawData.sale.name !=''">
              <!-- <el-divider >仓储信息</el-divider> -->
              <div class="optionClass">
                <span>客户名称</span>
                <span>{{checkResultByRawData.sale.name}}</span>
              </div>
              <div class="dashedClass"></div>
            </div>
            </div>
          </el-collapse-item>
      </el-collapse>



      <el-collapse v-model="activeName1" accordion style="margin-top:20px;" class="collapseClass" @change="rawChange">
        <el-collapse-item :name="1">
                <template slot="title"  >
                <div class="templateClass">
                  <span class="iconBorderClass"><i class="iconfont icon-zhiliang" ></i></span>
                  质量信息
                </div>
                  
                </template>

                <el-tabs v-model="activeName" @tab-click="handleClick" stretch>
                  <el-tab-pane v-if="checkResultByRawData.raw !== undefined && (checkResultByRawData.raw.length > 0 || Object.keys(checkResultByRawData.raw || {}).length)"  label="原料" name="first">

                      <div v-if="checkResultByRawData.raw">
                            <el-divider >检测信息</el-divider>

                        </div>
                          <div class="pdf" v-if="checkResultByRawData.raw.url !== ''">
                            <div class="pdf-tab">
                              <div>
                                <pdf
                                  v-for="i in numPages"
                                  :key="i"
                                  :src="pdfPath"
                                  :page="i"
                                >
                                </pdf>
                              </div>
                            </div>
                          </div>
                  </el-tab-pane>

                  <div v-if="activeName === 'second' && numShow">

                  <div v-if="checkResultByRawData.dna !== undefined && (checkResultByRawData.dna.length > 0 || Object.keys(checkResultByRawData.dna || {}).length)">
                      <el-divider style="width: 92%;margin: 0 auto;">基因测序</el-divider>
                      <div style="width:98%">
                        <el-card class="box-card card-class" style="width:98%">
                          <div slot="header" class="clearfix">
                            <span>PCB产物凝胶电池图</span>
                          </div>
                          <div  class="text item ">
                            <el-image  style="width: 100%;height: 200px;"
                                :src="checkResultByRawData.dna.images" 
                                :preview-src-list="checkResultByRawData.dna.images"
                                >
                              </el-image>
                          </div>
                        </el-card>
                        <el-card class="box-card card-class" style="width:98%">
                          <div slot="header" class="clearfix">
                            <span>样本DNA序列</span>
                          </div>
                          <div  class="text item" style="width:100%;display: flex;justify-content: center">
                            <canvas v-show="showErrMsg" ref="qrcodeMove"  style="display: flex;justify-content: center;align-items: center;height: 200px;width:100%;object-fit: cover"></canvas>
                          </div>
                        </el-card>

                        
                      </div>
                  </div>


                  <div v-if="checkResultByRawData.check !== undefined">
                    <template >
                      <div v-for="(data, type) in tableCheckResultByRawData" :key="type">
                        <el-divider style="width: 92%; margin: 0 auto;" v-if="data.length > 0">
                        {{ typeLabels[type] }}
                      </el-divider>

                      <div style="width: 98%;margin: 0 auto;" class="moveClass" v-if="data.length > 0">
                        <custom-table :data="data" :options="options" :title="checkResultByRawData.check.title" :lookWidth="lookWidth" />
                      </div>
                      </div>
                    </template>
                  </div>
                    <div v-if="checkResultByRawData.images">
                      <el-divider style="width: 92%;margin: 0 auto;">片形比较</el-divider>
                      <div style="width:98%">
                        <el-card v-for="item in checkResultByRawData.images" class="box-card card-class" style="width:98%">
                          <div  class="text item">
                            <el-image  style="width: 100%;height: 200px;"
                                :src="item" 
                                :preview-src-list="checkResultByRawData.images"
                                >
                              </el-image>
                          </div>
                        </el-card>

                        
                      </div>
                    </div>
                  
                  <div>
                    <el-divider style="width: 92%;margin: 0 auto;">检测信息</el-divider>
                    <!-- <div style="display: flex;justify-content: space-between;">
                      <span>执行标准</span>
                      <span>{{checkResultByRawData.quality.standards}}</span>
                    </div> -->
                    <!-- <div style="border-style: dashed; border-width: 0.9px;border-color: rgb(206, 206, 206);margin: 8px 0px;"></div> -->
                    <div class="pdf" v-if="checkResultByRawData.quality.picture_url !== ''">
                      <!-- <iframe  :src="checkResultByRawData.quality.picture_url"  frameborder="0" scrolling="no" style="width: 100%; height: 500px;border:none" /> -->
                      <div class="pdf-tab">
                        <div v-for="(item,index) in checkResultByRawData.quality.picture_url" :key="index">
                          <pdf
                            v-for="i in numPages1"
                            :key="i"
                            :src="item"
                            :page="i"
                          >
                          </pdf>
                        </div>

                      </div>
                    </div>
                  </div>
                  </div>
                  <el-tab-pane v-else label="成品" name="second">

                  <div v-if="checkResultByRawData.dna !== undefined && (checkResultByRawData.dna.length > 0 || Object.keys(checkResultByRawData.dna || {}).length)">
                      <el-divider style="width: 92%;margin: 0 auto;">基因测序</el-divider>
                      <div style="width:98%">
                        <el-card class="box-card card-class" style="width:98%">
                          <div slot="header" class="clearfix">
                            <span>PCB产物凝胶电池图</span>
                          </div>
                          <div  class="text item ">
                            <el-image  style="width: 100%;height: 200px;"
                                :src="checkResultByRawData.dna.images" 
                                :preview-src-list="checkResultByRawData.dna.images"
                                >
                              </el-image>
                          </div>
                        </el-card>
                        <el-card class="box-card card-class" style="width:98%">
                          <div slot="header" class="clearfix">
                            <span>样本DNA序列</span>
                          </div>
                          <div  class="text item" style="width:100%;display: flex;justify-content: center">
                            <canvas v-show="showErrMsg" ref="qrcodeMove"  style="display: flex;justify-content: center;align-items: center;height: 200px;width:100%;object-fit: cover"></canvas>
                          </div>
                        </el-card>

                        
                      </div>
                  </div>


                  <div v-if="checkResultByRawData.check !== undefined">
                    <template >
                      <div v-for="(data, type) in tableCheckResultByRawData" :key="type">
                        <el-divider style="width: 92%; margin: 0 auto;" v-if="data.length > 0">
                        {{ typeLabels[type] }}
                      </el-divider>

                      <div style="width: 98%;margin: 0 auto;" class="moveClass" v-if="data.length > 0">
                        <custom-table :data="data" :options="options" :title="checkResultByRawData.check.title" :lookWidth="lookWidth" />
                      </div>
                      </div>
                    </template>
                  </div>
                    <div v-if="checkResultByRawData.images">
                      <el-divider style="width: 92%;margin: 0 auto;">片形比较</el-divider>
                      <div style="width:98%">
                        <el-card v-for="item in checkResultByRawData.images" class="box-card card-class" style="width:98%">
                          <div  class="text item">
                            <el-image  style="width: 100%;height: 200px;"
                                :src="item" 
                                :preview-src-list="checkResultByRawData.images"
                                >
                              </el-image>
                          </div>
                        </el-card>

                        
                      </div>
                    </div>
                  
                  <div>
                    <el-divider style="width: 92%;margin: 0 auto;">检测信息</el-divider>
                    <!-- <div style="display: flex;justify-content: space-between;">
                      <span>执行标准</span>
                      <span>{{checkResultByRawData.quality.standards}}</span>
                    </div> -->
                    <!-- <div style="border-style: dashed; border-width: 0.9px;border-color: rgb(206, 206, 206);margin: 8px 0px;"></div> -->
                    <div class="pdf" v-if="checkResultByRawData.quality.picture_url !== ''">
                      <div class="pdf-tab">
                        <div v-for="(item,index) in checkResultByRawData.quality.picture_url" :key="index">
                          <pdf
                            v-for="i in numPages1"
                            :key="i"
                            :src="item"
                            :page="i"
                          >
                          </pdf>
                        </div>
                      </div>
                    </div>
                  </div>
                  </el-tab-pane>
                </el-tabs>
        </el-collapse-item>

      </el-collapse>
          

    </div>

    <!-- PC端底部 START -->
    <p class="marginTop companyClass" v-if="lookWidth >= 922">
      Copyright © 2005-{{ copyright.getFullYear() }} All Rights Reserved.
      深圳市和顺堂医药有限公司
    </p>
    <!-- PC端底部 END -->

    <!-- 移动端底部 START -->
    <p class="marginTop companyClass" v-else>
      © 2005-{{ copyright.getFullYear() }}
      深圳市和顺堂医药有限公司
    </p>
    <!-- 移动端底部 END -->
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import adapter from "webrtc-adapter";
// WebRTC适配器 只需要引入就ok
import { BrowserMultiFormatReader } from "@zxing/library";
import CMapReaderFactory from "vue-pdf/src/CMapReaderFactory.js";
import pdf from "vue-pdf";
import AMapLoader from '@amap/amap-jsapi-loader'
// 微信sdk
import wx from "weixin-js-sdk";
import { timeFormat } from "@/utils/common.js";

import customTable from './customTable'
import { convertPageToTraditional } from '@/utils/opencc'

// import { vuePdfApp } from 'vue-pdf-app';

// vuePdfApp.GlobalWorkerOptions.workerSrc = pdfjsWorker

// import 'vue-pdf-app/dist/icons/main.css';
// import QRCode from 'qrcodejs2' // 引入qrcode
import QRCode from 'qrcode'
// const pdfPath = require('@public/sample.pdf'); 

// import VueQr from 'vue-qr'

window._AMapSecurityConfig = {
    securityJsCode: '07ed823c286147225c2915d00c9960fe'  //填写你的安全密钥
}
export default {
  name: "HelloWorld",
  props: {
    checkResultOptions: {
      type: Array,
      required: true,
    },
  },
  components: {
    pdf,
    customTable
  },
  data() {
    return {
      // 列表数据  品管部
      quality: [],
      // 食品厂
      food: [],
      // 可预览图列表
      srcList: [],
      // 搜索框内容
      inputValue: "",
      // 当前日期
      copyright: new Date(),
      // 扫描
      codeReader: new BrowserMultiFormatReader(),
      // 扫描框显示状态
      openVideoSearchType: false,
      // 节流控制
      timer: null,
      // 页面可视宽度
      lookWidth: 0,
      foodActiveNames: ["1"],
      // 品管部 显示的列表数据
      tableOptions: [
        {
          title: "品名",
          prop: "name"
        },
        {
          title: "规格",
          prop: "goods_type"
        },
        {
          title: "产地",
          prop: "origin"
        },
        {
          title: "批号",
          prop: "goods_batch"
        },
        {
          title: "生产日期",
          prop: "production_time"
        },
        {
          title: "执行标准",
          prop: "standards"
        }
      ],
      foodOptions: [
        {
          title: "商品条码",
          prop: "goods_code"
        },
        {
          title: "品名",
          prop: "goods_name"
        },
        {
          title: "批号",
          prop: "batch_number"
        },
        {
          title: "生产日期",
          prop: "production_time"
        }
      ],
      foodGood: [],
      code: [],
      foodGoodPDF: [],
      src: "",
      pdfList: [],
      pdfUrl: "",
      numPages: 1,
      numPages1:1,
      // 显示文字
      showTitle: "",
      // 食品是否显示
      isShowTable: true,
      // 判断商品条件列表是否显示
      codeShowTable: true,
      // 判断品管部列表是否显示
      qualityShow: true,
      is_Dev: localStorage.getItem('_Dev'),
      isLoading: false,
      activeName:'first',
      activeName1:[1],
      show:false,
      active: 'first',
      checkResultByRawData:'',
      qualityPdfList:[],
      map: null,
      mapShow:false,
      templateOptions:{
        1:'精品中药',
        2: '中药饮片',
        3: '产品信息',
        4: '健康产品'
      },
      options: [
        {
          prop: 'name',
          label: '名称'
        },
        {
          prop: 'require',
          label: '标准规定'
        },
        {
          prop: 'standard',
          label: '企业内控'
        },
        {
          prop: 'value',
          label: '检验结果'
        }
      ],
      showErrMsg:'',
      template: '',
      isAMapLoaded: false, // 增加加载状态标识
      numValue:0,
      numShow:false,
      pdfSrc: null,
      // pdfPath:'./sample.pdf'
      pdfPath:'',
      pictureUrl:'',
      valuePush:[]
      // /api/uploads/files/20241129/b4280a01-0aa6-4286-b9c7-897f5da60362.pdf?type=cms
    };
  },
  created() {
    // 可视宽度
    this.lookWidth =
      document.body.offsetWidth || document.documentElement.offsetWidth;
    window.addEventListener("resize", () => {
      this.lookWidth =
        document.body.offsetWidth || document.documentElement.offsetWidth;
    });
    // debugger
    this.loadAMapLibrary()
    //   this.isAMapLoaded = true
  },
  //  watch: {
  //   // 监听 URL 变化
  //   'checkResultByRawData.quality.picture_url'(newVal) {
  //     if (newVal) this.pictureUrlLoadPdf()
  //   },
  //   'checkResultByRawData.raw.url'(newVal) {
  //     if (newVal) this.loadPdf()
  //   }
  // },
  mounted() {
    if (window.location.href.indexOf("lot") !== -1) {
      let value = window.location.href.split("lot=");
      this.inputValue = value[1].split("#")[0];
      this.getCheckList();
      // this.getCheckResultByRaw()
      
    }
    convertPageToTraditional()
  },
  computed: {
    hasExpandContent() {
      return this.quality.some(row => row.check !== undefined)
    },
    // 将不同的数据源整合到一个对象中
    tableCheckResultByRawData() {
      const { check } = this.checkResultByRawData;
      return {
        identify: check.identify || [],
        inspect: check.inspect || [],
        heavy_metal: check.heavy_metal || [],
        aflatoxin: check.aflatoxin || [],
        residual: check.residual || [],
        other_residual: check.other_residual || [],
        banned_pesticides: check.banned_pesticides || [],
        extracts: check.extracts || [],
        measurement: check.measurement || [],
      };
    },
    // 类型对应的中文标签
    typeLabels() {
      return {
        identify: '鉴别',
        inspect: '检查',
        heavy_metal: '重金属及有害元素',
        aflatoxin: '黄曲霉素',
        residual: '有机氯类农药残留',
        other_residual:'其它类农药残留',
        banned_pesticides: '禁用农药',
        extracts: '浸出物',
        measurement: '含量测定'
      };
    }
  },
  destroyed() {
    // 初始化 搜索框
    this.inputValue = "";
    // 关闭 扫描
    this.codeReader.reset();
  },
  methods: {
    timeFormat,
    // pdf加载时
    loadPdf(url) {
      const loadingTask = pdf.createLoadingTask(url)
        loadingTask.promise.then(pdf => {
          this.numPages = pdf.numPages // 获取总页数
        })
    },
    pictureUrlLoadPdf(url) {
       const loadingTask = pdf.createLoadingTask(url)
        loadingTask.promise.then(pdf => {
          this.numPages1 = pdf.numPages // 获取总页数
        })
    },
    // 获取 摄像头
    getUserMedia(constraints, success, error) {
      if (navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia(constraints)
          .then(success)
          .catch(error);
      } else if (navigator.webkitGetUserMedia) {
        navigator.webkitGetUserMedia(constraints, success, error);
      } else if (navigator.mozGetUserMedia) {
        navigator.mozGetUserMedia(constraints, success, error);
      } else if (navigator.getUserMedia) {
        navigator.getUserMedia(constraints, success, error);
      }
    },
    // 成功 回调方法
    success(stream) {
      this.codeReader.getVideoInputDevices().then(videoInputDevices => {
        const selectedDeviceId = videoInputDevices[1]
          ? videoInputDevices[1].deviceId
          : videoInputDevices[0].deviceId;

        this.codeReader.decodeFromInputVideoDeviceContinuously(
          selectedDeviceId,
          "video",
          (result, err) => {
            if (result) {
              if (result.text) {
                this.inputValue = result.text;
                this.openVideoSearchType = false;
                // 设置 节流控制
                if (this.timer) {
                  return false;
                } else {
                  this.timer = 1000;
                  let time = setTimeout(() => {
                    this.timer = null;
                    clearTimeout(time);
                  }, this.timer);
                  this.getCheckResultByRaw();
                }
                this.codeReader.reset();
              }
            }
          }
        );
      });
    },
    //失败 回调方法
    error(error) {
      this.codeReader.getVideoInputDevices().then(videoInputDevices => {
        const selectedDeviceId = videoInputDevices[1]
          ? videoInputDevices[1].deviceId
          : videoInputDevices[0].deviceId;

        this.codeReader.decodeFromInputVideoDeviceContinuously(
          selectedDeviceId,
          "video",
          (result, err) => {
            if (result) {
              if (result.text) {
                this.inputValue = result.text;
                this.openVideoSearchType = false;
                // 设置 节流控制
                if (this.timer) {
                  return false;
                } else {
                  this.timer = 1000;
                  let time = setTimeout(() => {
                    this.timer = null;
                    clearTimeout(time);
                  }, this.timer);
                  this.getCheckResultByRaw();
                }
                this.codeReader.reset();
              }
            }
          }
        );
      });
    },
    // 打开 摄像头
    openVideoSearch() {
      // 判断 是否是微信浏览器
      const ua = navigator.userAgent.toLowerCase();
      const isWeixin = ua.indexOf("micromessenger") != -1;
      // 微信浏览器 调用扫一扫
      if (isWeixin) {
        this.$axios
          .get(
            `https://saas.wellsoon.cn/Api/ConfigOption/getSign?url=${
              window.location.href.split("#")[0]
            }`
          )
          .then(res => {
            let that = this;
            let data = res.data.data;
            wx.config({
              // debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: data.appId, // 必填，公众号的唯一标识
              timestamp: data.timestamp, // 必填，生成签名的时间戳
              nonceStr: data.nonceStr, // 必填，生成签名的随机串
              signature: data.signature, // 必填，签名
              jsApiList: ["checkJsApi", "scanQRCode"] // 必填，需要使用的JS接口列表
            });
            wx.ready(() => {
              wx.scanQRCode({
                needResult: 1,
                // scanType: ["qrCode", "barCode"],
                scanType: ["barCode"],
                success(res) {
                  let result = res.resultStr.split(",");
                  that.inputValue = result[1];
                  // 设置 节流控制
                  if (that.timer) {
                    return false;
                  } else {
                    that.timer = 1000;
                    let time = setTimeout(() => {
                      that.timer = null;
                      clearTimeout(time);
                    }, that.timer);
                    that.getCheckList();
                  }
                }
              });
            });
          });
        // 非微信浏览器 调用摄像头
      } else {
        this.openVideoSearchType = true;
        if (this.openVideoSearchType) {
          if (
            navigator.mediaDevices.getUserMedia ||
            navigator.getUserMedia ||
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia
          ) {
            this.getUserMedia(
              {
                audio: false,
                video: {
                  sourceId: "default",
                  facingMode: { exact: "user" }
                }
              },
              this.success,
              this.error
            );
          } else {
            alert("不支持");
          }
        }
      }
    },
    // 关闭 摄像头
    closeVideo() {
      this.openVideoSearchType = false;
      this.codeReader.reset();
    },
    // 商品条码点击查询批号
    handleCellClick(row) {
      this.inputValue = row.batch_number;
      this.$nextTick(() => {
        // this.getList();
        this.getCheckResultByRaw(row.id)
      });
    },
    // pdf加载
    pdfTask(pdfUrl) {
      var self = this;
      var loadingTask = pdf.createLoadingTask(pdfUrl);
      loadingTask.promise
        .then(pdf => {
          self.pdfUrl = loadingTask;
          self.numPages = pdf.numPages;
        })
        .catch(err => {
          console.error("pdf加载失败");
        });
    },
    openList(){
      this.show = !this.show
    },
    getCheckList(){
      this.showTitle = "";
      let in_data = {}
      if (!this.is_Dev) {
        this.$aes.get(in_data, 'data', { code: this.inputValue })
      } else {
        in_data = { code: this.inputValue }
      }
      this.$axios
        .get("GoodsCheck/getCheckList", {
          params: in_data
        })
        .then(res => {
          this.template = ''
          // console.log("Array.isArray(res.data.data)",Object.keys(res.data.data))

          if(res.data.data.length === 0) {
            // console.log("111")
            this.showTitle = "未找到「" + this.inputValue + "」相关记录";
            this.quality = []
          } 
          if (Array.isArray(res.data.data) === true) {
            this.errMsg = ''
            this.codeShowTable = true
          this.checkResultByRawData = res.data.data

          
          this.code = this.checkResultByRawData
          this.quality = []

          console.log("this.code",this.code)
          if(this.code.length == 1){
            this.codeShowTable = false;
            this.getCheckResultByRaw(this.code[0].id)
          } else {
            this.codeShowTable = true
          }
          this.showErrMsg = true
          this.$refs.qrcodeMove.innerHTML = ''
          

          setTimeout(()=>{
            this.showErrMsg = true
          },10)
          this.qualityPdfList = []
        
          this.mapShow = true

          }
          if (res.data.code === 500 && res.data.show) {
            this.$message({
              message: res.data.msg,
              type: "warning"
            });
            this.template =''
          }
          
        })
        .finally(res => {
          console.log(res)
          this.$nextTick(() => convertPageToTraditional())

          this.isLoading = false;
          this.isShowTable = false;
          
          this.qualityShow = false;
          const timer = setTimeout(() => {
            this.isShowTable = true;
            this.codeShowTable = true;
            this.qualityShow = true;
            clearTimeout(timer);
          }, 0);
          // this.getCheckResultByRaw()

        })
        .catch(err => {});

    },
    // 获取 列表数据
    getCheckResultByRaw(id) {
      this.showTitle = "";
      this.codeShowTable = false
      this.numShow = false
      this.code = []
      let in_data = {}
      if (!this.is_Dev) {
        this.$aes.get(in_data, 'data', { batch_number: id })
      } else {
        in_data = { batch_number: id }
      }
      this.$axios
        .get("GoodsCheck/getCheckResultByRaw", {
          params: in_data
        })
        .then(res => {
          if (Array.isArray(res.data.data) === false) {
            this.errMsg = ''
          this.checkResultByRawData = res.data.data

          // this.showErrMsg =true
          console.log("this.checkResultByRawData",this.checkResultByRawData)
          this.template = this.checkResultByRawData.type
          console.log("this.template",this.template)
          // if(this.checkResultByRawData.food !== undefined){
          //   this.food = this.checkResultByRawData.food
          //   this.code = this.checkResultByRawData.code
          // } else {
          //   this.food = []
          //   this.code = []
          // }
          // console.log("this.checkResultByRawData.dna && Array.isArray(this.checkResultByRawData.dna) && this.checkResultByRawData.dna.length > 0",this.checkResultByRawData.dna && Array.isArray(this.checkResultByRawData.dna) && this.checkResultByRawData.dna.length > 0)
          // console.log("this.checkResultByRawData.raw !== undefined && (this.checkResultByRawData.raw.length > 0 || Object.keys(this.checkResultByRawData.raw || {}).length)",this.checkResultByRawData.raw !== undefined && (this.checkResultByRawData.raw.length > 0 || Object.keys(this.checkResultByRawData.raw || {}).length))
          if(this.checkResultByRawData.raw === undefined || this.checkResultByRawData.raw.length === 0){
            this.activeName = 'second'
            this.numValue = 1
            this.numShow = true
          } else {
            this.activeName = 'first'
          }

          

          this.quality = this.checkResultByRawData
          //  this.loadPdf()
          // 原料
          this.pdfPath = this.checkResultByRawData.raw.url
          if(this.pdfPath !== undefined && this.pdfPath !==''){
            this.loadPdf(this.pdfPath)
          }
          // this.valuePush。
          // console.log("valuePush",valuePush)
          if(this.checkResultByRawData.quality.picture_url.length > 0){
            this.checkResultByRawData.quality.picture_url.forEach(item=>{
              this.pictureUrlLoadPdf(item)  
            })
          }
          this.showErrMsg = true
          this.$refs.qrcodeMove.innerHTML = ''
          setTimeout(()=>{
            this.showErrMsg = true
          },10)
          this.qualityPdfList = []
          this.pdfTask(this.checkResultByRawData.quality.picture_url)
          this.mapShow = true

          } else {
            this.showTitle = "未找到「" + this.inputValue + "」相关记录";
            this.quality = []
          } 
          if (res.data.code === 500 && res.data.show) {
            this.$message({
              message: res.data.msg,
              type: "warning"
            });
            this.template =''
          }
          
        })
        .finally(res => {
          // console.log(res)
          this.$nextTick(() => convertPageToTraditional())
          this.isLoading = false;
          this.isShowTable = false;
          this.codeShowTable = false;
          this.qualityShow = false;
          const timer = setTimeout(() => {
            this.isShowTable = true;
            this.codeShowTable = true;
            this.qualityShow = true;
            clearTimeout(timer);
          }, 0);
          // this.getCheckResultByRaw()

        })
        .catch(err => {});
    },
    loadAMapLibrary(){
       AMapLoader.load({
          key: '572372381ecb8996dc43cbf9757b6301',
          securityJsCode: '07ed823c286147225c2915d00c9960fe',
          version: "2.0",
          plugins: ['AMap.Geocoder']
        })
    },
      initMap() {
        if (this.map) {
          this.map.destroy();
          this.map = null;
        }

      const containerId = this.lookWidth < 922 ? 'containerBox' : 'container';
      this.map = new AMap.Map(containerId, {
        resizeEnable: true,
        zoom: 12,
        center: [Number(this.checkResultByRawData.base.longitude), Number(this.checkResultByRawData.base.latitude)], //初始化地图中心点位置
      })
      this.addMarker([Number(this.checkResultByRawData.base.longitude), Number(this.checkResultByRawData.base.latitude)], 'Marker B')
      },
      addMarker(position, title) {
        const marker = new AMap.Marker({
          position: new AMap.LngLat(position[0], position[1]),
          title: title,
          map: this.map,
        })
      },
      statusFormat(row, column) {
           if (column === 'require') {
            return row.require || '-'
          }  else if (column === 'name') {
            return `${row.name}`
          }
           else {
          // 返回其他不需要处理的正常参数
            return row[column] || '-'
          }
        },
        handleClick(){
           this.showErrMsg = true
           this.$refs.qrcodeMove.innerHTML = ''
           this.$refs.qrcode.innerHTML = ''
          this.$nextTick(()=>{
            this.showErrMsg =true
            QRCode.toCanvas(this.$refs.qrcode, this.checkResultByRawData.dna.code, { width: 256 }, function (error) {
              if (error) {
                console.error('二维码生成失败:', error);
              }
            })
            // console.log("this.checkResultByRawData.dna.code",this.checkResultByRawData.dna.code)
            QRCode.toCanvas(this.$refs.qrcodeMove, this.checkResultByRawData.dna.code, { width: 256 }, function (error) {
              if (error) {
                console.error('二维码生成失败:', error);
              }
            })
          })
        },
        handleChange(val) {
          if(val=== 'base'){
            this.loadAMapLibrary()
            this.isAMapLoaded = true
            this.initMap()
          }
        },
        rawChange(){
          if(this.activeName === 'second' && this.numValue === 1){
            this.handleClick()
            this.numValue = 0
          }
        }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
* {
  margin: 0;
  padding: 0;
}

.el-col {
  border-radius: 4px;
}

.title-container {
  text-align: center;
}

// .inputSearch {
//   // width: 100%;
//   text-align: center;
// }

.tableClass {
  width: 1200px;
  margin: 20px auto;
  .search-video-shadom {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background: rgba($color: #000000, $alpha: 1);
    z-index: 99;
    .close-search-video-shadom {
      position: absolute;
      top: 20px;
      right: 20px;
    }
    .search-video-shadom-tips {
      position: absolute;
      bottom: 100px;
      left: 50%;
      transform: translateX(-50%);
      color: #fff;
    }
  }
}

.marginTop {
  margin-top: 50px;
}

.demo-table-expand label {
  width: 74px;
  color: #99a9bf;
}

.pictureUrl .el-form-item__label {
  width: 100px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
}

.companyClass {
  text-align: center;
}

@media screen and (max-width: 480px) {
  .tableClass {
    width: 100% !important;
  }
}

.limiter {
  width: 100%;
  margin: 0 auto;
}

.container-table {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  padding: 33px 30px;
}

.wrap-table {
  width: 960px;
  overflow: hidden;
  border-bottom: 1px solid #ebeef5;
}

.table {
  width: 100%;
  display: table;
  margin: 0;
}

@media screen and (max-width: 768px) {
  .table {
    display: block;
  }
}

.row {
  display: table-row;
  background: #fff;
}

.row.header {
  color: #ffffff;
  background: #f5f7fa;
}

@media screen and (max-width: 768px) {
  .row {
    display: block;
  }

  .row.header {
    padding: 0;
    height: 0px;
  }

  .row.header .cell {
    display: none;
  }

  .row .cell:before {
    font-family: Poppins-Bold;
    font-size: 12px;
    color: #808080;
    line-height: 1.2;
    text-transform: uppercase;

    margin-bottom: 13px;
    content: attr(data-title);
    min-width: 98px;
    display: block;
  }
}

.cell {
  display: table-cell;
}

@media screen and (max-width: 768px) {
  .cell {
    display: block;
  }
}

.row .cell {
  font-size: 15px;
  color: #666666;
  line-height: 1.2;

  padding-top: 15px;
  padding-bottom: 15px;
  border-top: 1px solid #f2f2f2;
  border-left: 1px solid #f2f2f2;
}

.resultsClass {
  border-right: 1px solid #ebeef5;
}

.row.header .cell {
  font-size: 18px;
  line-height: 1.2;

  padding-top: 15px;
  padding-bottom: 15px;
}

.row .cell:nth-child(1) {
  width: 60px;
}

.row .cell:nth-child(2) {
  width: 260px;
}

.row .cell:nth-child(3) {
  width: 60px;
}

.table,
.row {
  width: 100% !important;
}

@media (max-width: 768px) {
  .row {
    border-bottom: 1px solid #f2f2f2;
    margin: 0;
  }

  .row .cell {
    border: none;
  }

  .row .cell {
    font-size: 18px;
    color: #555555;
    line-height: 1.2;
  }

  .table,
  .row,
  .cell {
    width: 100% !important;
  }
}

.phone-table {
  padding: 0 5%;
  .phone-table-items {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 5%;
    margin-bottom: 20px;
    &:last-of-type {
      margin-bottom: none;
    }
    .el-card__body {
      width: 100%;
      .image {
        display: block;
        width: 100%;
      }
      .el-collapse-item__header {
        font-size: 20px;
      }
      .el-collapse-item__content {
        font-size: 15px;
        &:last-of-type {
          padding-bottom: 0;
        }
      }
    }
  }
}
.title-class {
  margin: 25px 0px;
  text-align: center;
}

.container {
  height: 500px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
.showTitle-class {
  text-align: center;
  margin: 20px 0px;
}
.codeTableDataClass {
  cursor: pointer;
}
.miniCodeTable {
  width: 90%;
  font-size: 12px;
}

.collapse {
  .item {
      .Content {
          height: 0px;
          overflow: hidden;
          transition: height 0.3s;
      }
  }
}

.optionClass-img{
  width: 300px; /* 或父容器实际宽度 */
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 强制覆盖elementUI默认样式 */
.base-images .el-carousel__item {
  height: 100% !important;
  min-width: 100% !important;
}

.base-images .el_carousel__item_image .el-image__inner {
  object-fit: cover !important; /* 图片覆盖式填充 */
  object-position: center center; /* 居中裁剪 */
  width: 100% !important;
  height: 100% !important;
}


.optionClass{
  display: flex;
  justify-content: space-between;
  padding: 0px 3px;
  margin-bottom: 5px;
}
.dashedClass{
  border-style: dashed;
  border-width: 0.9px;
  border-color: rgb(206, 206, 206);
  margin: 8px 0px;
}

.card-class{
  border-radius: 0.8rem;
  margin-bottom: 0.1rem;
  margin-top: 20px;
  width: 30%;
  margin-right: 5px;
}

.blockClass{
  display: flex;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 6px;
  background: rgba(115, 80, 23, 0.05);
  border-radius: 8px;
  margin-bottom: 10px;
  justify-content: space-around;
  align-items: center;
}
.iconfontClass{
  font-size: 26px;
}
.blockRigthClass{
  display: flex;
  align-items: center;
  flex-flow: column;
}
.carouselNameClass{
  padding: 0.1rem;
  text-align: center;
  background: #f8f8f8;
  // box-shadow: rgba(66, 116, 144, 0.18) 0px -0.05rem 0.25rem 0px;
  border-radius: 83px;
  position: relative;
}


.padding-class{
  padding: 0px 20px;
}


#container {
  width: 100%;
  height: 1080px;
}

#containerBox {
  width: 100%;
  height: 280px;
}

.iconBorderClass{
  padding: 4px 8px;
  border-radius: 3px;
}

.pdfClass{
  text-align: center;
  margin-top: 20px;
}
.productClass{
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
.productBoxClass{
  width: 98%;
  border: 1px solid #cccc;
  border-radius: 10px;
  padding: 18px;
  // padding: 10px;
  margin: 0 auto;

  // color: #bd9916;
}

.produceClass:nth-child(4n){ 
  margin-right: 0; 
}
.produceClass:last-child{ 
  margin-right: auto; 
}

.fixed-image{
  width: 300px;  /* 固定宽度 */
  height: 200px; /* 固定高度 */
  object-fit: cover;  /* 保证图片不变形 */
}

.el_carousel_image{
  width: 100%;
  height: 100%;
}

.custom-image{
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain; /* 完整显示 */
}
.icon-color{
  font-size: 22px;
  color: #c49e0d;
}

</style>

<style>
.foodUrl .el-form-item__label {
  display: block;
}

.collapseClass .el-collapse-item__header{
  border: 0px;
  box-shadow: 0 0.1rem 0.85rem 0 rgb(111 111 111 / 9%);
  padding: 0px 15px;
  border-radius: 2rem;
  margin-bottom: 10px;
  color: #c49e0d;
}
.collapseClass .el-collapse-item__wrap{
  border-bottom:0px
}

.collapseClass{
  border:0px;
}

.card-class .el-card__body{
    padding: 10px;
}

.el-collapse {
  border-top:0px !important;
  border-bottom:0px !important;
}

div[ref="qrcodeMove"] {
  margin-top: 20px;
  display: inline-block;
}
.moveClass .el-table td{
  padding: 2px 0px
}

.moveClass .el-table .cell{
  padding-right:8px
}

.moveClass .el-rate__icon{
  margin-right:0px
}
.el-collapse-item__header{
  font-size: 14px !important;
  font-weight: normal !important;
}
.productBoxClass .el-divider__text{
  font-size: medium;
  font-weight: revert;
}

/* .codeTableDataClass .el-tag{
  color: #207f4C;
  background-color: #eef7f2;
  border-color: #eef7f2;
} */
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue